<template>
  <el-dialog :append-to-body="true" :visible.sync="value" :show-close="false" width="550px" custom-class="public-pool-drop-actived-dialog" @closed="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
      <h1 class="title">请选择时间</h1>
      <i class="el-icon-close" style="cursor: pointer;" @click="closed"></i>
    </div>
    <div class="time-group">
      <div class="time-con">
        <el-time-picker v-model="timeStart" placeholder="请选择时间" size="small" class="time-item" :picker-options="{format: 'HH:mm'}" value-format="HH:mm" format="HH:mm"></el-time-picker>
        <span class="time-range">至</span>
        <el-select v-model="type" size="small" class="time-type">
          <el-option label="当日" :value="0"></el-option>
          <el-option label="次日" :value="1"></el-option>
        </el-select>
        <el-time-picker v-model="timeEnd" placeholder="请选择时间" size="small" class="time-item" :picker-options="{format: 'HH:mm'}" value-format="HH:mm" format="HH:mm"></el-time-picker>
      </div>
      <div class="button-con">
        <el-button size="small" @click="closed">取消</el-button>
        <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default{
  name: 'PublicPoolTimePicker',
  data () {
    return {
      value: false,
      type: 0,
      timeStart: '',
      timeEnd: ''
    }
  },
  methods: {
    open (data) {
      this.value = true;
      if (data) {
        this.timeStart = data.unconfirmed_daily_protect_start_time;
        this.timeEnd = data.unconfirmed_daily_protect_end_time;
        this.type = data.unconfirmed_daily_protect_time_cross;
      }
    },
    closed () {
      this.value = false;
      this.type = 0;
      this.timeStart = '';
      this.timeEnd = '';
    },
    handleConfirm () {
      if (!this.timeStart || !this.timeEnd) {
        this.$message.error('请先选择时间');
        return null;
      } 
      const a = this.timeToSec(this.timeStart);
      const b = this.timeToSec(this.timeEnd);
      if (this.type == 0 && a >= b) {
        this.$message.error('截止时间点必须大于开始时间点');
        return null;
      }
      if (this.type == 1 && b >= a) {
        this.$message.error('截止时间点，不得大于开始时间点');
        return null;
      }
      this.$emit('confirm', {unconfirmed_daily_protect_time_cross: this.type, unconfirmed_daily_protect_start_time: this.timeStart, unconfirmed_daily_protect_end_time: this.timeEnd})
      this.closed();
    },
    timeToSec (time) {
      if (time) {
        const s = '';
        const hour = time.split(':')[0];
        const min = time.split(':')[1];
        return Number(hour * 3600) + Number(min * 60);
      }
    }
  },
}
</script>
<style lang="less">
.public-pool-drop-actived-dialog{
  .time-group{
    padding: 20px;
    .time-con{
      .box();
    }
    .time-item{
      width: 170px;
    }
    .time-type{
      width: 100px;
      margin-right: 10px;
    }
    .time-range{
      font-size: 13px;
      color: #333;
      display: block;
      padding: 0 10px;
    }
  }
  .button-con{
    text-align: center;
    margin-top: 40px;
    button{
      width: 100px;
      text-align: center;
    }
  }
}
</style>